// 🎯 Página principal para ubicar productos de devoluciones - Main page for locating returned items
import { useParams } from 'react-router-dom';
import { LocateContainer } from './components/containers/LocateContainer';

export const Locate = () => {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return <div>ID no válido</div>;
  }

  return <LocateContainer returnedId={parseInt(id, 10)} />;
};

export default Locate;

